
define('jst!tooltips/_members_count',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="members-count-tooltip">\n  <%= data.internal %> <%= t(\'Employees #dashboard\')%><br />\n  <%= data.external %> <%= t(\'External members #dashboard\') %>\n</div>');
 });

